import React, { useState, useEffect } from 'react';
import '../css/NewNotificationAlert.css';

const NewNotificationAlert = ({ notification, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (notification && notification.message) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose(); // Callback if needed when auto-closing
      }, 5000); // Disappear after 5 seconds

      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [notification, onClose]);

  const handleClose = () => {
    setVisible(false);
    if (onClose) onClose(); // Callback if needed when manually closing
  };

  const handleAlertClick = () => {
    console.log('[NewNotificationAlert] Clicked. Notification data:', notification);
    if (notification && notification.link && notification.link !== '#') {
      console.log('[NewNotificationAlert] Navigating to link:', notification.link);
      window.location.href = notification.link;
      handleClose(); // Đóng modal sau khi nhấp
    }
  };

  if (!visible || !notification) {
    return null;
  }

  return (
    <div className="new-notification-alert">
      <div 
        className="new-notification-alert-content" 
        onClick={handleAlertClick}
        style={{cursor: (notification && notification.link && notification.link !== '#') ? 'pointer' : 'default'}}
      >
        <p><strong>{getNotificationTitle(notification)}</strong></p>
        <p>{notification.message}</p>
      </div>
      <button onClick={handleClose} className="new-notification-alert-close">
        &times;
      </button>
    </div>
  );
};

// Helper function to get a Vietnamese title
const getNotificationTitle = (notification) => {
  if (!notification || !notification.type) return 'Thông báo';
  switch (notification.type.toUpperCase()) {
    case 'REQUEST': return 'Yêu cầu mới';
    case 'LEAVE_REQUEST': return 'Đơn xin nghỉ phép';
    case 'APPROVAL': return 'Phê duyệt';
    case 'SYSTEM': return 'Thông báo hệ thống';
    case 'INCIDENT': return 'Báo cáo sự cố';
    case 'REPORT': return 'Báo cáo mới';
    case 'TASK': return 'Công việc mới';
    case 'INFO': return 'Thông tin';
    case 'EVALUATION': return 'Đánh giá nhân viên';
    default: return 'Thông báo'; // Default generic title
  }
};

export default NewNotificationAlert;
